import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconList(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M8 6a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM4 9a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H4Zm5 0a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H9ZM4 5a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2H4Zm4 9a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm-4-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H4Zm4 5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm-4-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
